import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Github, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">DigitalNext</span>
            </div>
            <p className="text-gray-400 mb-4">
              Uw partner in digitale transformatie. Ontwikkel essentiële vaardigheden 
              voor de moderne werkplek en blijf voorop in de digitale revolutie.
            </p>
            <div className="flex space-x-4">
              <button className="text-gray-400 hover:text-white transition-colors">
                <Github className="w-5 h-5" />
              </button>
              <button className="text-gray-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Quick links removed per new navigation design */}

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Bronnen</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-white transition-colors">
                  Documentatie
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt-6 text-center text-gray-400">
          <p>&copy; 2025 DigitalNext by Vrules. Alle rechten voorbehouden.</p>
        </div>
      </div>
    </footer>
  );
};
